// @flow

/**
 * Module dependencies.
 */

import { darken } from 'polished';

/**
 * Basic.
 */

const black = '#000';
const white = '#fff';
const transparent = `rgba(255, 255, 255, 0)`;

/**
 * Brand.
 */

const brandPrimary = '#da895b';
const brandPrimaryDark = darken(0.2, brandPrimary);
const brandSecondary = '#1b354a';

/**
 * Neutral.
 */

const abbey = '#54585c';
const brown = '#b09485';
const brownOrange = '#b9947e';
const gallery = '#ececec';
const grayChateau = '#a0a2a4';
const outerSpace = '#2e3438';
const rollingStone = '#7a7d80';
const silverSand = '#c6c7c8';

/**
 * Forms.
 */

const red = 'red';

/**
 * Shades of Blue.
 */

const shadesOfBlue = {
  bigStoneDarker: '#13283a',
  bigStoneLighter: '#1b354a',
  iron: '#dee0e2',
  oxfordBlue: '#3d4f5d',
  paleSky: '#687681',
  regentGray: '#939da5',
  submarine: '#bec4c9'
};

/**
 * Shades of Sand.
 */

const shadesOfSand = {
  cararraLighter: '#edebe7',
  desertStormDarker: '#bec4c9',
  nomad: '#bdb4a7',
  silverRust: '#c9c1b7',
  swirl: '#d5cfc7',
  westarDarker: '#e1dcd7'
};

/**
 * Shades of Sand II.
 */

const shadesOfSand2 = {
  cararraDarker: '#e9e6e1',
  cararraMedium: '#eeece8',
  desertStormLighter: '#fcfcfb',
  pampasDarker: '#f3f1ee',
  pampasLighter: '#f8f7f6',
  westarLighter: '#e5e1db'
};

/**
 * Export `gradients`.
 */

export const gradients = {
  sand: `linear-gradient(180deg, ${shadesOfSand2.pampasDarker} 0%, ${white} 100%)`
};

/**
 * Export `colors`.
 */

export const colors = {
  abbey,
  black,
  brandPrimary,
  brandPrimaryDark,
  brandSecondary,
  brown,
  brownOrange,
  gallery,
  grayChateau,
  outerSpace,
  red,
  rollingStone,
  shadesOfBlue,
  shadesOfSand,
  shadesOfSand2,
  silverSand,
  transparent,
  white
};



// WEBPACK FOOTER //
// ../src/client/styles/colors.js